/**
 * PrestadorPreviewCard: Preview en vivo de cómo se verá la tarjeta del prestador
 * en la home pública de la Guía TS+ mientras se edita en el admin.
 * Envuelve PrestadorCardBonda mapeando los campos del form (`prestadorForm`)
 * al formato que espera la tarjeta.
 */
import React from 'react';
import { Gift } from 'lucide-react';
import PrestadorCardBonda from '../beneficios/PrestadorCardBonda';

export default function PrestadorPreviewCard({ prestadorForm = {}, categorias = [], iconMap = {} }) {
  const cat = categorias.find((c) => c.id === prestadorForm.categoria_id);
  const categoriaIcon = iconMap[cat?.icono];

  // Mapear al shape que espera PrestadorCardBonda
  const prestadorPreview = {
    id: prestadorForm.id || 'preview',
    nombre: prestadorForm.nombre || 'Nombre del prestador',
    beneficio: prestadorForm.beneficio || 'Descripción del beneficio',
    logo_url: prestadorForm.logo_url,
    imagen_principal: prestadorForm.imagen_principal,
    imagenes: prestadorForm.imagenes,
    paquetes: prestadorForm.paquetes,
    origen: prestadorForm.origen,
  };

  const badge = prestadorForm.destacado
    ? 'DESTACADO'
    : prestadorForm.origen === 'rueda_turismo'
    ? 'RUEDA TURISMO'
    : null;
  const badgeClass = prestadorForm.destacado
    ? 'bg-amber-500'
    : prestadorForm.origen === 'rueda_turismo'
    ? 'bg-sky-600'
    : 'bg-purple-600';

  return (
    <div className="bg-gradient-to-br from-purple-50 via-white to-purple-100/40 border border-purple-200 rounded-2xl p-3 shadow-inner">
      <PrestadorCardBonda
        prestador={prestadorPreview}
        categoriaIcon={categoriaIcon || Gift}
        onClick={() => {}}
        badge={badge}
        badgeClass={badgeClass}
        testId="prestador-preview-card"
      />
      {/* Info de la categoría seleccionada */}
      <p className="text-[10px] text-center text-gray-500 mt-2">
        {cat ? (
          <>Categoría: <span className="font-medium text-purple-700">{cat.nombre}</span></>
        ) : (
          <span className="text-amber-600 italic">Seleccioná una categoría</span>
        )}
      </p>
    </div>
  );
}
